<template>
  <v-card class="review-availability">
    <v-subheader>
      <v-icon medium color="success" class="mr-2">people</v-icon>
      {{date}} <span class="ml-2">Заполнена доступность на ревью уровня {{level}}</span>
    </v-subheader>
    <v-layout row>
      <v-flex>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Доступность: </span>{{availability}}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: "ReviewAvailability",
    props: ["date", "description", "level", "availability"]
  }
</script>

<style scoped>
  .review-availability {
    border: 1px solid #78909C;
  }
</style>